<div id="modalWrapper">
	<div class="modal-header">
		<h5 class="modal-title">{{title}}</h5>
		<div id="buttons">
			<button type="button" class="close" aria-label="Close" (click)="close()">
				<i class="fa-solid fa-xmark"></i>
			</button>
			<button type="button" class="close" aria-label="Close" (click)="backToOverview(true)">
				<i class="fa-solid fa-arrow-left"></i>
			</button>
		</div>
	</div>
	<div class="modal-body">
		<table>
			<tr>
				<th colspan="3">Antwoorden van <span class="studentName"> <span [ngClass]="{'capitalize': capitalizeNames(answerData['student']['studentName'])}">{{answerData['student']['studentName']}} </span><span>({{answerData['student']['studentStudyLevel']}})</span></span></th>
			</tr>
			<tr *ngFor="let answer of answerData['questions']; let i = index">
				<td class="clickable" (click)="showQuestionOverview(answer)" style="font-weight: bold;">
					<i class="fa-solid fa-eye"></i> {{answer.questionLetter}} <div style="font-weight: 400;" [innerHTML]="answer['questionTitle']"></div>
				</td>
				<td>
					<div>{{answer.answer}}</div>
					<div class="statusButtons" *ngIf="answer.answer">
						<button (click)="updateAnswerState('perfect', answer['questionId'], answerData['student']['studentId'])"
							[ngClass]="answer['answerStatus'] == 'PERFECT' ? 'sel-perfect' : ''"
							class="btn btn-sm answer-button btn-success"
							[attr.data-question-id]="'qna-' + i + '-question'">Goed!</button>
						<button (click)="updateAnswerState('correct', answer['questionId'], answerData['student']['studentId'])"
							[ngClass]="answer['answerStatus'] == 'CORRECT' ? 'sel-correct' : ''"
							class="btn btn-sm answer-button btn-warning"
							[attr.data-question-id]="'qna-' + i + '-question'">Voldoende</button>
						<button (click)="updateAnswerState('wrong', answer['questionId'], answerData['student']['studentId'])"
							[ngClass]="answer['answerStatus'] == 'WRONG' ? 'sel-wrong' : ''"
							class="btn btn-sm answer-button btn-danger"
							[attr.data-question-id]="'qna-' + i + '-question'">Onvoldoende</button>
					</div>
				</td>
			</tr>
		</table>
	</div>
</div>